export enum ForwardModalTab {
  Recent = 'recent',
  DriveTree = 'driveTree',
  Share = 'share',
}
